var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"timer custom-timer"},[_vm._v(" "+_vm._s(_vm.timeRemaining.days)+" "),_c('span',[_vm._v("D")]),_vm._v(": "+_vm._s(_vm.timeRemaining.hours)+" "),_c('span',[_vm._v("H")]),_vm._v(": "+_vm._s(_vm.timeRemaining.minutes)+" "),_c('span',[_vm._v("M")]),_vm._v(": "+_vm._s(_vm.timeRemaining.seconds)+" "),_c('span',[_vm._v("S")])])
}
var staticRenderFns = []

export { render, staticRenderFns }